import { render, staticRenderFns } from "./AccountDetailsV2.vue?vue&type=template&id=bd9f9606&scoped=true&"
import script from "./AccountDetailsV2.vue?vue&type=script&lang=js&"
export * from "./AccountDetailsV2.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetailsV2.vue?vue&type=style&index=0&id=bd9f9606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9f9606",
  null
  
)

export default component.exports